<template>
    <Layout is-crm class="order-stylesheet-page" :content-class="'content--centered'">
        <h1 v-t="'crm.stylesheet.title'" />
        <OrderStylesheet :order-id="orderId" />
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import { OrderStylesheet } from '../../components';

export default {
    name: 'OrderStylesheetPage',
    components: {
        Layout,
        OrderStylesheet,
    },
    computed: {
        orderId() {
            const { id } = this.$route.params;
            return id;
        },
        orderRoute() {
            return {
                name: 'orders-id',
                params: { id: this.orderId },
            };
        },
    },
};
</script>
